'use strict';
function setAddressAutocompleteValidation () {
    if (window.Parsley) {
        if (!window.Parsley._validatorRegistry.validators.selectedaddress) {
            window.Parsley.addValidator('selectedaddress', {
                validateString: function (value) {
                    return !(value.length > 0);
                }
            });
        }
    }
}

function closeAllLists(elmnt, inp) {
    /* Close all autocomplete lists in the document, except the one passed as an argument */
    const lists = document.querySelectorAll('.autocomplete-items');
    lists.forEach(list => {
        if (elmnt !== list && elmnt !== inp) {
            list.parentNode.removeChild(list);
        }
    });
    if (inp) {
        inp.setAttribute('aria-expanded', 'false');
    }
}

function createAutocompleteItem(data, index) {
    /* Create a single autocomplete item */
    const item = document.createElement('DIV');
    item.className = 'text-autocomplete-row';
    item.setAttribute('role', 'option');
    item.setAttribute('id', 'autocomplete-option-' + index);
    item.setAttribute('aria-selected', 'false');
    item.dataset.id = data.Id;
    item.dataset.type = data.Type;
    item.innerHTML = data.Text + ' ' + data.Description;
    return item;
}

function autocomplete(inp, arr) {
    setAddressAutocompleteValidation();
    /* The autocomplete function takes two arguments: the text field element and an array of possible autocompleted values */
    let currentFocus = -1;

    const val = inp.value.trim();
    closeAllLists(null, inp);
    if (!val) return;

    inp.setAttribute('role', 'combobox');
    inp.setAttribute('aria-autocomplete', 'list');
    inp.setAttribute('aria-expanded', 'true');
    inp.setAttribute('aria-controls', inp.id + '-autocomplete-list');
    inp.setAttribute('aria-activedescendant', '');

    const container = document.createElement('DIV');
    container.setAttribute('id', inp.id + '-autocomplete-list');
    container.setAttribute('class', 'autocomplete-items cc-address-autocomplete');
    container.setAttribute('role', 'listbox');
    inp.parentNode.appendChild(container);

    arr.forEach((data, index) => {
        const item = createAutocompleteItem(data, index);
        item.addEventListener('click', function () {
            $('body').trigger('checkout:shippingAddressAutocompleteElement', {
                id: this.dataset.id,
                type: this.dataset.type,
            });
            $(inp).trigger('change');
            closeAllLists(null, inp);
        });
        container.appendChild(item);
    });

    // Add row at the end of the list to show the "Add address manually" link
    const showAddressForm = document.createElement('DIV');
    showAddressForm.className = 'text-autocomplete-row';
    showAddressForm.setAttribute('role', 'option');
    showAddressForm.setAttribute('id', 'autocomplete-option-' + arr.length);
    showAddressForm.setAttribute('aria-selected', 'false');
    showAddressForm.innerHTML = $('.js-add-address-manually').html();
    showAddressForm.addEventListener('click', function () {
        closeAllLists(null, inp);
        $('.js-add-address-manually').click();
    });
    container.appendChild(showAddressForm);

    inp.addEventListener('keydown', function (e) {
        const list = document.getElementById(inp.id + '-autocomplete-list');
        const items = list ? list.getElementsByTagName('div') : [];
        if (e.keyCode === 40) { // Arrow DOWN
            currentFocus++;
            setActive(items);
        } else if (e.keyCode === 38) { // Arrow UP
            currentFocus--;
            setActive(items);
        } else if (e.keyCode === 13) { // ENTER
            e.preventDefault();
            if (currentFocus > -1 && items[currentFocus]) {
                items[currentFocus].click();
            }
        }
    });

    document.addEventListener('click', function (e) {
        closeAllLists(e.target, inp);
    });

    function setActive(items) {
        if (!items.length) return;
        removeActive(items);
        currentFocus = (currentFocus + items.length) % items.length;
        const activeItem = items[currentFocus];
        activeItem.classList.add('autocomplete-active');
        activeItem.setAttribute('aria-selected', 'true');
        inp.setAttribute('aria-activedescendant', activeItem.id);
    }

    function removeActive(items) {
        Array.from(items).forEach(item => {
            item.classList.remove('autocomplete-active');
            item.setAttribute('aria-selected', 'false');
        });
    }
}

module.exports = {
    autocomplete
};
